import type { ErrorComponentProps } from "@tanstack/react-router";
import { Button } from "./ui";
import styles from "./route-error.module.css";

export function RouteError({ error, reset }: Pick<ErrorComponentProps, "error" | "reset">) {
  const outdated = /Unable to preload CSS|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(error.message);
  return <section className={styles.error} role="alert">
    <h1>{outdated ? "Не удалось загрузить файлы админки" : "Не удалось открыть раздел"}</h1>
    <p>{outdated ? "Проверь подключение к интернету и обнови страницу." : "Попробуй открыть раздел ещё раз. Если ошибка повторится, обнови страницу."} Перед обновлением сохрани введённый текст: несохранённые изменения могут быть потеряны. Если обновление не поможет, обратись к администратору.</p>
    <div className={styles.actions}>
      {!outdated && <Button onClick={reset}>Попробовать снова</Button>}
      <Button variant="primary" onClick={() => window.location.reload()}>Обновить страницу</Button>
    </div>
  </section>;
}
